/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */

import { Box, Fade, useScrollTrigger } from "@mui/material";
import { motion } from "framer-motion";
import {
  DefaultLayoutZIndex,
  heightBottomNav,
} from "../../../_utils/constraints";

const ScrollTop = (props) => {
  const { children, window } = props;

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          position: "fixed",
          bottom: heightBottomNav + 10,
          right: 10,
          zIndex: DefaultLayoutZIndex + 4,
          cursor: "pointer",
        }}
      >
        {/* Adding framer-motion for animation and shadow effect */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0.5 }}
          animate={{ scale: 1, opacity: 1 }}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.3 }}
          style={{
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // shadow effect
            borderRadius: "50%", // optional: if you're using a circular button
          }}
        >
          {children}
        </motion.div>
      </Box>
    </Fade>
  );
};

export default ScrollTop;
